import Colors from '@/constants/Colors';
import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';
import styled from 'styled-components';

export const StyledLibraryLevelFilter = styled.div`
  display: flex;
  background-color: ${Colors.backgroundPaleBlueDark};
  box-shadow: ${Colors.boxShadow};
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 20px;

  .levels {
    display: grid;
    flex: 1;
    grid-template-columns: repeat(5, 1fr);
    gap: 20px;

    .level.card {
      display: flex;
      flex-direction: column;
      justify-content: center;
      box-shadow: ${Colors.boxShadow};
      background-color: white;
      border-radius: 10px;
      padding: 5px;
      gap: 10px;
      border: 4px solid white;
      cursor: pointer;
      transition: all 0.3s;

      &.active {
        border-color: ${Colors.primary};

        .card-header .card-title {
          color: ${Colors.primary};
        }
      }

      &:hover:not(.active, .disabled) {
        border-color: ${Colors.primary}55;
      }

      &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      .card-header {
        display: flex;
        align-items: center;
        gap: 10px;

        .card-image {
          position: relative;
          height: 40px;
          width: 40px;
          border-radius: 50px;
          overflow: hidden;

          .icon {
            width: 100%;
            height: 100%;
          }
        }

        .card-title {
          font-size: 20px;
          font-weight: bold;
          color: ${Colors.textDark};
          flex: 1;
          white-space: nowrap;
          overflow: hidden;
        }
      }

      .card-grades {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        font-size: 16px;
        text-align: center;
        background-color: ${Colors.backgroundPaleBlue};
        border-radius: 10px;
        padding: 10px;

        .grades-list {
          display: flex;

          .ant-tag {
            border: none;
            background-color: white;
            box-shadow: ${Colors.boxShadow};
          }
        }
      }
    }
  }

  &.size-small {
    padding: 5px;
    .levels .level.card {
      padding: 0px 3px;
      border-width: 3px;

      .card-title {
        font-size: 16px;
        text-align: center;
      }
      .card-image,
      .card-grades {
        display: none;
      }
    }
  }

  @media (max-width: ${MediaQueryBreakpoints.xl}) {
    padding: 5px;
    margin-bottom: 10px;

    &.size-default,
    &.size-small {
      .levels {
        grid-template-columns: repeat(4, 1fr);
        gap: 5px;

        .level.card {
          gap: 5px;
          padding: 3px 5px;
          border-width: 2px;

          .card-header {
            gap: 5px;
            .card-image {
              height: 25px;
              width: 25px;

              svg {
                width: 15px !important;
                height: 15px !important;
              }
            }
            .card-title {
              font-size: 16px;
            }
          }

          .card-grades {
            padding: 2px 5px;
            .grade-text {
              font-size: 14px;
            }
          }

          &.all {
            grid-column: span 4;
            flex-direction: row;

            .card-header {
              gap: 10px;
              .card-image {
                height: 20px;
                width: 20px;

                svg {
                  width: 12px !important;
                  height: 12px !important;
                }
              }
            }
          }
        }
      }
    }
  }
  @media (max-width: ${MediaQueryBreakpoints.lg}) {
    &.size-default,
    &.size-small {
      .levels .level .card-grades {
        display: none;
      }
    }
  }

  @media (max-width: ${MediaQueryBreakpoints.md}) {
    &.size-default,
    &.size-small {
      .levels {
        grid-template-columns: repeat(2, 1fr);
        .level:first-child {
          grid-column: 1 / -1;
        }
        flex-direction: column;
        gap: 5px;

        .level.card {
          &:first-child {
            .card-header {
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              gap: 10px;

              .card-title {
                flex: 1;
              }
            }
          }

          .card-image {
            height: 30px !important;
            width: 30px !important;

            svg {
              width: 15px !important;
              height: 15px !important;
            }
          }

          .card-title {
            flex: 1;
            font-size: 16px;
          }

          .card-grades {
            display: none;
          }

          &.all {
            grid-column: span 2;
          }
        }
      }
    }
  }
`;
